import { DashboardHeader } from 'features/dashboard/dashboard-header/DashboardHeader';
import { CenteredDashboardContent } from 'features/dashboard/DashboardContent';
import StatusPageSuccess from 'components/layout/StatusPage/StatusPageSuccess';
import { StepPage } from 'features/subscription-process/navigation/Steps/StepPage';
import { NsKey } from 'enums/NsKey';
import { FormikProps } from 'formik';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { FC, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActorFormValues } from '../hooks/optim/useSubmitActorForm';
import { NewActor } from './NewActor';

export const NewActorPage: FC = () => {
  const navigate = useNavigate()
  const { t } = useDynamicTranslation([NsKey.ActorForm, NsKey.Common]);
  const [isFormValid, setIsFormValid] = useState(false)
  const [isActorCreated, setIsActorCreated] = useState(false)

  const formikRef = useRef<FormikProps<ActorFormValues>>(null);
  const onClickSubmit = () => formikRef.current?.submitForm();

  if (isActorCreated) {
    return <StatusPageSuccess
      title='ACTOR_FORM.STATUS_PAGE_SUCCESS.TITLE'
      description='ACTOR_FORM.STATUS_PAGE_SUCCESS.DESCRIPTION'
      next={{
        label: 'ACTOR_FORM.STATUS_PAGE_SUCCESS.BACK',
        onClick: () => setIsActorCreated(false)
      }}
    />
  }

  return (
    <CenteredDashboardContent>
      <DashboardHeader/>
      <StepPage
        nextConfig={{
          label: t('COMMON.VALIDATE'),
          onClick: onClickSubmit,
          disabled: !isFormValid,
        }}
        prevConfig={{ label: t('COMMON.CANCEL'), onClick: () => navigate(-1) }}
      >
        <NewActor formikRef={formikRef} onValidationChange={setIsFormValid} />
      </StepPage>
    </CenteredDashboardContent>
  );
};
